/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { BusinessCapacityHeaderControlPanelEntryPointEntrypointProps } from './BusinessCapacityHeaderControlPanelEntryPoint.entrypoint.types.tsx';

type BusinessCapacityHeaderControlPanelEntryPointComponent = EntryPointComponent<
	{},
	{},
	BusinessCapacityHeaderControlPanelEntryPointEntrypointProps,
	{}
>;

// Note: Unlike software-capacity, business-capacity cannot use preload queries because
// the backend requires projectId-based ARIs, but projectId is only available at runtime
// via useProjectContext(). The query is loaded at runtime in the component instead.

export const businessCapacityHeaderControlPanelEntryPoint: EntryPoint<
	BusinessCapacityHeaderControlPanelEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<BusinessCapacityHeaderControlPanelEntryPointComponent>(
		/* webpackChunkName: "async-jira-business-capacity-header-control-panel" */ './BusinessCapacityHeaderControlPanelEntryPoint.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
